<template>
  <div>

    <!-- Navbar itself -->
    <q-toolbar color="white">

      <!-- Menu -->
      <v-button flat dense round @click="$emit('leftDrawerToogle')" color="primary" icon="menu"
                tour="briefing-2" :tour-title="$T('menu')"
                :tour-content="$T('click here to access menu items')"></v-button>

      <q-toolbar-title class="tb-btn-height text-left">
        <router-link :to="{ name: user ? 'home' : 'welcome' }" tour="briefing-3"
                     :tour-title="$T('dashboard')"
                     :tour-content="$T('click here to return to dashboard')">
          <img src="../../img/iqos-grey.svg" class="tb-btn-height gt-xs" :alt="appName"/>
          <img src="../../img/iqos-icon.svg" class="tb-btn-height xs" :alt="appName"/>
        </router-link>

      </q-toolbar-title>
      <GoBack/>

      <v-button v-if="checkSSO()" flat dense rounded @click="onRetail()" color="primary"
                tour="briefing-2">
                <span class="gt-xs gt-md on-right q-pr-sm capitalize" style="color: steelblue; font-size: 1.2em">
                    <q-icon name="launch" class="avatar"> </q-icon> {{ $T('Back to Sale') }}
                </span>
      </v-button>

      <!-- Lending Point Selector -->
      <lp-selector v-if="isCourier" tour="briefing-7"
                   :tour-title="$T('lending point selector')"
                   :tour-content="$T('click here to change the lending point')">
      </lp-selector>
      <!-- Lending Point Inactive message -->
      <q-toolbar-title v-if="isPosInactive" class="text-left text-orange">
                <span class="q-pr-sm capitalize">
                    <q-icon name="warning"> </q-icon>  {{ $T('POS Inactive') }}
                </span>
      </q-toolbar-title>
      <!-- Points of sale -->
      <v-button flat dense rounded color="primary"
                v-if="user.lending_point_id !== Null && user.lending_points.length > 1" tour="briefing-4"
                :tour-title="$T('profile settings')"
                :tour-content="$T('click here to access your profile settings')">
        <span class="gt-xs on-right q-pr-sm capitalize" style="font-size: 1.2em">
                    <q-icon name="store"> </q-icon>{{ 'Lending Point - ' + user.lending_point.description }}
                </span>
        <q-popover fit v-if="!checkSSO()">
          <q-list dense link v-for="value in user.lending_points" v-bind:key="value.id">
            <q-item @click.native="changePOS(value.id)" v-close-overlay>
              <q-item-side icon="store"/>
              {{ value.description }}
            </q-item>
          </q-list>
        </q-popover>
      </v-button>
      <!-- User -->
      <v-button flat dense rounded color="primary" v-if="user" tour="briefing-4"
                :tour-title="$T('profile settings')"
                :tour-content="$T('click here to access your profile settings')">

        <!-- <img :src="user.photo_url" class="avatar tb-btn-square"> -->
        <span class="gt-xs on-right q-pr-sm capitalize" style="font-size: 1.2em">
           <q-icon name="person" class="avatar"> </q-icon>
                    {{ user.name | firstAndLast }}
        </span>

        <q-popover fit>
          <q-list dense link>
            <q-item @click.native="$router.push({ name: 'settings.profile' })" v-close-overlay>
              <q-item-side icon="settings"/>
              {{ $T('settings') }}
            </q-item>
            <q-item v-if="!checkSSOOpen()" @click.native="logout" v-close-overlay>
              <q-item-side icon="exit to app"/>
              {{ $T('log out') }}
            </q-item>
          </q-list>
        </q-popover>
      </v-button>

      <v-button flat dense rounded color="primary" v-if="user && user.roles" tour="briefing-4">

        <span class="gt-xs on-right q-pr-sm capitalize" style="font-size: 1.2em">
          {{ user.role.name }}
           <q-icon name="arrow_drop_down" class="avatar"> </q-icon>
        </span>

        <q-popover fit>
          <q-list link v-for="(role,i) in user.roles" :key="i">
            <q-item @click.native="updateRole(role.id)" v-close-overlay>
              {{ role.name }}
            </q-item>
          </q-list>
        </q-popover>
      </v-button>

      <soft-phone></soft-phone>

      <!-- Help -->
      <v-button flat dense round @click="$tours['helpTour'].start()"
                color="primary" icon="live help"></v-button>

      <locale-dropdown tour="briefing-7"
                       :tour-title="$T('language')"
                       :tour-content="$T('click here to change the language')"></locale-dropdown>
    </q-toolbar>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import LocaleDropdown from './LocaleDropdown';
import {
  QToolbar,
  QToolbarTitle,
  QIcon,
  QList,
  QItem,
  QItemSide,
  QChip,
  QPopover,
  QPageSticky,
  QFab,
  QFabAction,
  QTooltip
} from 'quasar-framework';

import GoBack from "./GoBack";
import LpSelector from "./LpSelector";
import axios from "axios";
import SoftPhone from "./SoftPhone";

export default {
  data: () => ({
    appName: window.config.appName
  }),

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    isCourier() {
      return this.user && this.user.role.name === 'Courier';
    },
    isPosInactive() {
      return this.user && (this.user.role.name === 'Lending Point'
              || this.user.role.name === 'Lending Point Indirect'
              || this.user.role.name === 'Lending Point Hostesses')
          && this.user.lending_point && this.user.lending_point.active === 0;
    },
  },

  components: {
    SoftPhone,
    LpSelector,
    LocaleDropdown,
    QToolbar,
    QToolbarTitle,
    QIcon,
    QList,
    QItem,
    QItemSide,
    QChip,
    QPopover,
    QFab,
    QFabAction,
    QPageSticky,
    QTooltip,
    GoBack
  },

  mounted () {
    this.checkOpenSession();
  },

  methods: {
    checkOpenSession() {
      if (window.parent.location && window.location.origin === window.parent.location.origin && this.checkSSOOpen()) {
         this.logout()
      }
    },

    checkSSO() {
      return this.getCookie('sso') === 'true';
    },

    checkSSOOpen() {
      return this.getCookie('sso-open') === 'true';
    },

    async logout() {
      // Log out the user.

      let domain = this.getCookie('domain');
      let salesUrl = config.salesUrl;
      let retailUrl = config.retailUrl;

      await this.$store.dispatch('auth/logout');

      if (domain == 3) {
        location.replace(retailUrl);
      } else if (domain == 7) {
        location.replace(salesUrl);
      }

      this.$router.push({name: 'login'});

    },
    async changePOS(pos_id) {
      await axios.get('/api/v1/change-pos/' + pos_id)
          .then(response => {
            if (response.status == 200) {
              location.replace('/');
            }
          });
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    onRetail() {
      window.location.href = config.retailUrl;
    },
    async updateRole(role_id) {
      await axios.get('/api/v1/update-role/' + role_id)
          .then(response => {
            if (response.status == 200) {
              location.replace('/');
            }
          });
    },
  }
};


</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Navbar.vue